import React, { useState } from 'react';
import {
    Avatar,
    Box,
    Button,
    IconButton,
    Paper,
    Typography
} from '@mui/material';
import PhotoCamera from '@mui/icons-material/PhotoCamera';
import BrandSideLogo from '@/components/BrandSideLogo';
import { ToastContainer } from 'react-toastify';
import customerService from '@/service/customer.service';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ToastService from '@/service/toaster.service';
import customerAuthService from '@/service/auth.service/customer.auth.service';

export default function UploadProfilePicture() {
    const [image, setImage] = useState(null);
    const userId = useSelector(state => state.auth.auth).id;
    const [isUploadDisabled, setIsUploadDisabled] = useState(true);
    const navigate = useNavigate();

    const [previewUrl, setPreviewUrl] = useState(null);

    const handleImageChange = (e) => {
        const file = e.target.files?.[0];
        if (file) {
            setImage(file); // store file
            setPreviewUrl(URL.createObjectURL(file)); // store preview URL
            setIsUploadDisabled(false); // Enable upload button
        }
    };

    const handleUpload = async () => {
        if (!image) return;

        console.log('Uploading image:', image);

        const formData = new FormData();
        formData.append('profile_picture', image);
        try {
            await customerAuthService.updateUserData(userId, formData);
            ToastService.success('Profile picture uploaded successfully.');
            setTimeout(() => {
                // navigate('/customer/dashboard');
                navigate('/customer/search-brokers');
            }, 500);
        } catch (error) {
            // Handle error (e.g., show error message)
            ToastService.error('Error uploading profile picture. Please try again.');
        }
    };

    const handleMoveToDashboard = () => {
        console.log('Skipping to dashboard...');
        // navigate('/customer/dashboard');
        navigate('/customer/search-brokers');
    };

    return (
        <Box display="flex" flexDirection={{ xs: "column", sm: "row" }} width="100%" height="100vh">
            <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                flex="1"
                bgcolor="primary.main"
                color="white"
                width="100%"
            >
                <BrandSideLogo />
            </Box>
            <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                flex="1"
                bgcolor="background.default"
            >
                <ToastContainer />
                <Paper elevation={5} sx={{ p: 4, maxWidth: 400, width: "100%" }}>
                <Typography variant="h5" mb={3} color="#5E5ACF" fontWeight="bold" align="center">
                        Upload Picture
                    </Typography>


                    <Box mt={5} mb={2} textAlign="center">
                            <Avatar
                            src={previewUrl}
                            alt="Profile"
                            sx={{
                                width: 120,
                                height: 120,
                                margin: "0 auto",
                                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                            }}
                            />
                            <IconButton
                            color="primary"
                            aria-label="upload picture"
                            component="label"
                            sx={{ mt: 1 }}
                            >
                            <input
                                hidden
                                accept="image/*"
                                type="file"
                                onChange={handleImageChange}
                            />
                            <PhotoCamera />
                            </IconButton>
                        </Box>

                    <Button
                        variant="contained"
                        fullWidth
                        className="btn-upload"
                        style={{ marginTop: '2rem', color: 'black', fontWeight: 'bold' }}
                        onClick={handleUpload}
                        disabled={isUploadDisabled}
                    >
                        Upload
                    </Button>

                    <Typography
                        variant="body2"
                        color="primary"
                        sx={{ cursor: "pointer", mt: 2, textAlign: 'center' }}
                        onClick={handleMoveToDashboard}
                    >
                        Skip
                    </Typography>
                </Paper>
            </Box>
        </Box>
    );
}
